import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appMonthpicker]'
})

export class MonthpickerDirective implements AfterViewInit {

  constructor(private elRef: ElementRef) {
  }
  ngAfterViewInit(): void {
    this.elRef.nativeElement.style.color = 'blue';
    this.elRef.nativeElement.style.fontSize = '20px';
  }
}



// WEBPACK FOOTER //
// ./src/app/monthpicker.directive.ts